import { useFormik } from 'formik';
import * as Yup from 'yup';

export function useVisitValidation(onSubmit) {
  const initialValues = {
    datetime: '',
    isArrived: false,
    price: '',
    iva: '',
    paymentMethod: '',
    observation: '',
  };

  const formik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      datetime: Yup.string().required('El campo fecha y hora es requerido'),
      isArrived: Yup.boolean().required('El campo asistencia es requerido'),
      price: Yup.mixed().when('isArrived', {
        is: true,
        then: () =>
          Yup.mixed()
            .required('El campo precio es requerido')
            .transform((value, originalValue) => {
              if (typeof originalValue === 'string') {
                // Convert value with format (24.000.000) to number (24000000)
                return Number(originalValue.replace(/\./g, ''));
              }
              return value;
            })
            .test(
              'is-number',
              'El precio debe ser un número válido',
              (value) => !isNaN(value),
            ),
        otherwise: () => Yup.mixed().notRequired(),
      }),
      iva: Yup.string().when('isArrived', {
        is: true,
        then: () => Yup.string().required('El campo iva es requerido'),
        otherwise: () => Yup.string().notRequired(),
      }),
      paymentMethod: Yup.string().when('isArrived', {
        is: true,
        then: () =>
          Yup.string().required('El campo forma de pago es requerido'),
        otherwise: () => Yup.string().notRequired(),
      }),
      observation: Yup.string().when('isArrived', {
        is: true,
        then: () => Yup.string().required('El campo observación es requerido'),
        otherwise: () => Yup.string().notRequired(),
      }),
    }),
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit,
  });

  return formik;
}
